import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["icon"];
var __jsx = React.createElement;
import * as React from 'react';
import Link from 'next/link';
import styled, { css } from 'styled-components';
import * as ds from '@bob/design-system';
import { styles as S } from '@bob/design-system';
import * as url from '@bob/url';
import { blob } from '@bob/utils/blob';
export function PillarAccordion(_ref) {
  var pillar = _ref.pillar,
      brush = _ref.brush,
      criteria = _ref.criteria;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  return __jsx(Accordion, {
    title: __jsx(Brush, {
      as: "h4",
      $color: brush
    }, pillar),
    isOpen: isOpen,
    onToggle: function onToggle() {
      if (ds.utils.browser.isMobile()) {
        setIsOpen(!isOpen);
      }
    }
  }, __jsx(CriteriaList, null, criteria.map(function (criterion) {
    var blobData = blob();
    return __jsx(CriteriaItem, {
      key: criterion.name
    }, __jsx(Link, {
      href: url.tag({
        name: criterion.name,
        slug: criterion.slug
      }).path,
      prefetch: false
    }, __jsx("a", null, __jsx(CriteriaHead, null, __jsx(ds.BlobBackground, {
      color: blobData.color,
      marginBottom: 50 * (1 / 9),
      marginLeft: 50 * (1 / 9),
      marginRight: 50 * (1 / 9),
      marginTop: 50 * (1 / 9),
      variant: blobData.variant
    }), __jsx(CriteriaIcon, {
      icon: criterion.icon,
      size: 25
    }), __jsx(S.copy.Text3, {
      as: "h4"
    }, criterion.name)))), __jsx(S.copy.Text4, {
      as: "p"
    }, criterion.description));
  })));
}

function CriteriaIcon(_ref2) {
  var icon = _ref2.icon,
      rest = _objectWithoutProperties(_ref2, _excluded);

  switch (icon) {
    case 'carbon-neutral':
      {
        return __jsx(ds.illustrations.criteria.CarbonNeutral, rest);
      }

    case 'circular-economy':
      {
        return __jsx(ds.illustrations.criteria.CircularEconomy, rest);
      }

    case 'fair-trade':
      {
        return __jsx(ds.illustrations.criteria.FairTrade, rest);
      }

    case 'inventory-optimized':
      {
        return __jsx(ds.illustrations.criteria.OptimizedInventory, rest);
      }

    case 'made-in-europe':
      {
        return __jsx(ds.illustrations.criteria.MadeInEurope, rest);
      }

    case 'made-in-france':
      {
        return __jsx(ds.illustrations.criteria.MadeInFrance, rest);
      }

    case 'natural-materials':
      {
        return __jsx(ds.illustrations.criteria.NaturalMaterials, rest);
      }

    case 'organic':
      {
        return __jsx(ds.illustrations.criteria.Organic, rest);
      }

    case 'recycled-materials':
      {
        return __jsx(ds.illustrations.criteria.RecycledMaterials, rest);
      }

    case 'short-supply-chain':
      {
        return __jsx(ds.illustrations.criteria.ShortSupplyChain, rest);
      }

    case 'sustainable':
      {
        return __jsx(ds.illustrations.criteria.Sustainable, rest);
      }

    case 'upcycled-materials':
      {
        return __jsx(ds.illustrations.criteria.UpcycledMaterials, rest);
      }

    case 'zero-waste':
      {
        return __jsx(ds.illustrations.criteria.ZeroWaste, rest);
      }
  }
}

var CriteriaHead = styled.div.withConfig({
  displayName: "PillarAccordion__CriteriaHead",
  componentId: "sc-j6oglt-0"
})(["align-items:center;display:flex;margin-bottom:4px;", "{height:34px;opacity:0;padding:18px;position:absolute;transform:scale(0.7);transition:opacity 200ms ease-in-out,transform 200ms ease-in-out;width:34px;z-index:0;}", "{margin-right:3px;visibility:visible;z-index:0;}", "{margin-left:10px;}&:hover{", "{opacity:1;transform:scale(1);}}"], ds.BlobBackground, ds.illustrations.Illustration, S.copy.Text3, ds.BlobBackground);
var CriteriaList = styled.ul.withConfig({
  displayName: "PillarAccordion__CriteriaList",
  componentId: "sc-j6oglt-1"
})([""]);
var CriteriaItem = styled.li.withConfig({
  displayName: "PillarAccordion__CriteriaItem",
  componentId: "sc-j6oglt-2"
})(["margin:25px 0;", "{margin-left:38px;}"], S.copy.Text4);

function brushBackground($color) {
  return ds.utils.svg.toDataUrl(ds.brush.full.FullBrush3, {
    width: 100,
    fill: $color
  });
}

var Brush = styled(S.heading.TitleCardArticle).withConfig({
  displayName: "PillarAccordion__Brush",
  componentId: "sc-j6oglt-3"
})(["", " background-size:100px auto;background-repeat:no-repeat;background-position:left center;padding:1em;margin:-1em;"], function (_ref3) {
  var $color = _ref3.$color;
  return css(["background-image:url('", "');"], brushBackground($color));
});
var Accordion = styled(ds.Accordion).withConfig({
  displayName: "PillarAccordion__Accordion",
  componentId: "sc-j6oglt-4"
})(["margin-top:27px;@media screen and (", "){", ",", "{display:none;}", "{display:block;}", "{cursor:default;}}", "{margin-bottom:7px;}"], ds.breakpoint.TABLET, ds.icons.ChevronUp, ds.icons.ChevronDown, S.accordion.Content, S.accordion.Toggle, S.accordion.Toggle);